import React from 'react';
import Link from 'next/link';
import { ImageLoader, Trackable } from '@/components/common';
import { EventCategoryType } from '@/types/EventCategoryType.type';

interface CategoryCardProps {
  category: EventCategoryType;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <div className='relative block h-28 w-full overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl md:h-40'>
      <Trackable
        eventName='Click'
        eventScope='Category Card'
        eventProps={{
          categoryId: category._id,
          categoryName: category.name,
        }}
      >
        <Link href={`/category/${category.categoryCode}`} passHref>
          <ImageLoader
            src={category.iconUrl}
            alt={'Category ' + category.name || ' Image'}
            width={300}
            height={300}
            className='size-full h-[12rem] rounded-md'
            imageClassName='object-cover'
            aria-label={'Category ' + category.name || ''}
          />
          <div className='absolute inset-0 bottom-0 rounded-2xl bg-gradient-to-t from-black/90 via-black/30' />
          <div className='absolute -bottom-2 mb-2 line-clamp-2 w-full overflow-hidden rounded-b-2xl bg-gradient-to-t from-black via-black/60 p-2 px-3 text-left text-xs font-semibold text-white md:text-sm md:whitespace-pre-line'>
            <p className='w-[90%] truncate text-sm font-bold tracking-wider sm:text-sm sm:tracking-wide uppercase'>
              {category?.name}
            </p>
          </div>
        </Link>
      </Trackable>
    </div>
  );
}
